<template>
    <Popper>
        <button class="tooltip">
            <i class="fas fa-info"></i>
        </button>
        <template #content :content="$props.content">
            <div
                style="
                    max-width: 250px;
                    color: #ffffff;
                    background-color: #00adc6;
                    border-radius: 4px;
                    padding: 12px;
                    font-weight: normal;
                    font-size: 12px;
                "
            >
                {{ content }}
            </div>
        </template>
    </Popper>
</template>

<script>
import { defineComponent } from "vue";
import Popper from "vue3-popper";

export default defineComponent({
    components: {
        Popper,
    },
    props: {
        content: {
            type: String,
            required: true,
        },
    },
});
</script>